import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { CommonModule, Location } from '@angular/common';
import { BrisbaneDatePipe } from '../../../shared/pipes/brisbane-date.pipe';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import ApexCharts from 'apexcharts';
import { debounceTime, distinctUntilChanged, Subject, take, tap } from 'rxjs';
import { userRoles } from '../../../../environments/environment';
import { EventCalendarComponent } from '../../../shared/components/calender-layout/event-calendar.component';
import { ButtonComponent } from '../../../shared/components/custom-button/button.component';
import { TableComponent } from '../../../shared/components/custom-table/table.component';
import { AddEventComponent } from '../../../shared/components/dialog/add-event/add-event.component';
import { AddStudentComponent } from '../../../shared/components/dialog/add-student/add-student.component';
import { AddTeacherComponent } from '../../../shared/components/dialog/add-teacher/add-teacher.component';
import {
  AlertDialogComponent,
  AlertDialogData,
} from '../../../shared/components/dialog/alert-dialog/alert-dialog.component';
import { CommonDialogComponent } from '../../../shared/components/dialog/commom/commom-dialog.component';
import { ContactDialogComponent } from '../../../shared/components/dialog/contact-details/contact-details-dialog.component';
import { SendEmailDialogComponent } from '../../../shared/components/dialog/send-email/send-email-dialog.component';
import { ExportDropdownComponent } from '../../../shared/components/export-dropdown/export-dropdown';
import { FilterMenuComponent } from '../../../shared/components/filter/filter-menu.component';
import { CustomToastComponent } from '../../../shared/components/toast/custom-toast.component';
import { HttpService } from '../../../shared/services/http.service';
import { UrlParserService } from '../../../shared/services/url-parser.service';

interface TeacherDialogData {
  initialData?: APIResponse;
  EditMode: boolean;
  ViewMode: boolean;
  schoolID: string;
  eventId?: string;
  addStudent?: boolean;
}

interface FilterData {
  [key: string]: any;
}

interface APIResponse {
  status: boolean;
  message: string;
  data: any[] | { [key: string]: any };
}

interface listAPIResponse {
  status: boolean;
  message: string;
  data: {
    totalRecord: number;
    items: any[];
  };
}

interface UsersPagedResponse {
  items: any[];
  totalRecords?: number;
  totalRecord?: number;
}

function isPagedResponse(
  data: UsersPagedResponse | any[] | { [key: string]: any },
): data is UsersPagedResponse {
  if (Array.isArray(data)) {
    return false;
  }
  return !!(data && typeof data === 'object' && 'items' in data);
}

@Component({
  selector: 'app-event-list',
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    ButtonComponent,
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    EventCalendarComponent,
    ExportDropdownComponent,
    BrisbaneDatePipe,
  ],
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss'],
  animations: [
    trigger('collapse', [
      state(
        'open',
        style({
          maxHeight: '1000px',
          opacity: 1,
          overflow: 'hidden',
        }),
      ),
      state(
        'closed',
        style({
          maxHeight: '0',
          opacity: 0,
          overflow: 'hidden',
        }),
      ),
      transition('open <=> closed', animate('300ms ease-in-out')),
    ]),
    trigger('fadeIn', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [animate('300ms ease-in', style({ opacity: 1 }))]),
    ]),
  ],
})
export class EventListComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('actionButtons') actionButtonsTemplate!: TemplateRef<any>;
  @ViewChild('statusUpdateContent') statusUpdateContent!: TemplateRef<any>;
  @ViewChild('addEventContent') addEventContent!: TemplateRef<any>;
  @ViewChild('filterMenu') filterMenu!: FilterMenuComponent;
  @ViewChild('filterDropdownContainer') filterDropdownContainer!: ElementRef;
  @ViewChild('chartContainer', { static: false }) chartContainer!: ElementRef;
  @ViewChild('actionButtonsTeacher') actionButtonsTeacher!: TemplateRef<any>;
  @ViewChild('actionButtonsStudent') actionButtonsStudent!: TemplateRef<any>;
  @ViewChild('actionButtonsContact') actionButtonsContact!: TemplateRef<any>;
  @ViewChild(TableComponent) tableComponent!: TableComponent;
  private searchSubject = new Subject<string>();

  showStatusDropdown = false;
  isInternal = false;
  showApprovalStatusDropdown = false;
  statusOptions: any[] = [];
  approveStatusOptions: any[] = [];
  teacherStatusOption: any[] = [];
  selectedSegment: 'teachers' | 'students' | 'contacts' = 'students';
  loading = false;
  pageloading = false;
  approvalStatusLoading = false;
  chartLoading = false;
  tableLoading = false;
  studentTabelLoading = false;
  isEventHeld: boolean = false;
  engagementMetrics: any = null;
  columns: string[] = [
    'event name',
    'school',
    'Date & time',
    'organiser',
    'location',
    'status',
  ];
  XAdminColumns: string[] = [
    'Event name',
    'Event type',
    'Date & time',
    'Organizer',
    'Location',
    'Status',
  ];
  XTeacherColumns: string[] = [
    'Event name',
    'Date',
    'Teacher name',
    'Approval status',
    'Location',
    'Status',
    'Number of students',
  ];
  XStudentColumns: string[] = [
    'Event name',
    'Date',
    'Teacher approval',
    'Approval status',
    'Location',
    'Status',
  ];

  secondaryColumn: string[] = [
    'event name',
    'event type',
    'Date & time',
    'Teacher name',
    // 'approval status',
    'location',
    'number of students',
    'status',
  ];

  externalColumn: string[] = [
    'event name',
    'Student name',
    'date',
    // 'teacher approval',
    // 'approval status',
    'location',
    'status',
  ];
  teacherApprovalStatusLoading = false;
  teacherApprovalStatusLoadingText = false;
  pendingTeacherApprovalStatus: string | null = null;
  adminApprovalStatusLoading = false;
  adminApprovalStatusLoadingText = false;
  pendingAdminApprovalStatus: string | null = null;
  teachercolumns: string[] = [
    'schoolName',
    'teacherName',
    'email',
    'phoneNumber',
  ];
  studentcolumns: string[] = [
    'school name',
    'student name',
    'status',
    'attended',
    'PD points',
    'notes',
  ];

  eventStudentsList: string[] = [
    'school name',
    'student name',
    'status',
    'media consent',
    'notes',
  ];
  eventStudentsHeldList: string[] = [
    'school name',
    'student name',
    'status',
    'attended',
    'PD points',
    'media consent',
    'notes',
  ];

  teacherstudentcolumns: string[] = ['student name', 'status', 'notes'];
  teacherstudentadmincolumns: string[] = [
    'school name',
    'student name',
    'status',
    'media consent',
    'notes',
  ];
  contactcolumns: string[] = ['schoolName', 'studentName', 'attended', 'notes'];
  teacherstudentHeldColumns: string[] = [
    'student name',
    'status',
    'attended',
    'PD points',
    'notes',
  ];
  teacherstudentHeldadmincolumns: string[] = [
    'school name',
    'student name',
    'status',
    'attended',
    'PD points',
    'media consent',
    'notes',
  ];
  tableEvents: any[] = [];
  fullData: any[] = [];
  search: string = '';
  searchControl = new FormControl('');
  statusControl = new FormControl('');
  eventTypeControl = new FormControl('');
  locationControl = new FormControl('');
  viewMode = false;
  selectedSchoolID: any = null;
  selectedEvent: any = null;
  selectedStatus: boolean | null = null;
  comments: string = '';
  isExpanded = false;
  showEventModal: any = '';
  eventViewMode = false;
  Role = localStorage.getItem('userRole') || '';
  currentSlideIndex: number = 0;
  form!: FormGroup;
  eventOptions: any[] = [];
  eventManagers: any[] = [];
  audienceTypes: any[] = [];
  focusAreaOptions: any[] = [];
  regionOptions: any[] = [];
  uploadedFiles: File[] = [];
  imagePreviews: string[] = [];
  showFilterMenu = false;
  currentFilters: FilterData = {};
  filterBackdrop = false;
  teacherData: any[] = [];
  studentData: any[] = [];
  eventStudentList: any[] = [];
  contactData: any[] = [];
  teacherMode: boolean = false;
  teacherStudentData: any[] = [];
  teacherloading: boolean = false;
  private chart: ApexCharts | null = null;
  chartData: { date: string; registrations: number }[] = [];
  chartInitialized: boolean = false;
  syncLoading: boolean = false;
  shareLoading: boolean = false;
  tableSegment: string = 'admin';
  showDelete: boolean = false;
  private currentRequestId = 0;
  private autoSlideInterval: any;
  eventViewFTCH: boolean = false;
  skeletonEvents: any[] = Array(5).fill({});
  skeletonStudents: any[] = Array(5).fill({});
  skeletonTeachers: any[] = Array(5).fill({});
  skeletonContacts: any[] = Array(5).fill({});
  adminViewEvent: boolean = false;
  teacherViewEvent: boolean = false;
  studentViewEvent: boolean = false;
  resChartData: any = null;
  downloadInProgress: boolean = false;
  downloadingRowId: string | null = null;
  userRoles = {
    createEvent: false,
    export: false,
    listItem: {
      view: false,
      edit: false,
      delete: false,
      statusChange: false,
    },
  };
  listViewRoles = {
    shareEmail: false,
    syncWithAsana: false,
    statusChange: false,
    edit: false,
    assignStudent: false,
    studentList: {
      edit: false,
      statusChange: false,
      mediaConsent: false,
    },
  };
  isEditInProgress: boolean = false;
  private statusDropdownClickListener: (() => void) | null = null;
  studentEventView: boolean = false;
  isSuperAdmin: boolean = localStorage.getItem('userRole') === 'superadmin';

  currentPage: number = 1;
  pageSize: number = 10;
  totalRecords: number = 0;
  sortColumn: string | null = null;
  sortDirection: 'asc' | 'desc' | '' = '';
  currentExportParams: any = {};
  isSearchExport: boolean = false;
  constructor(
    private dialog: MatDialog,
    private httpService: HttpService,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private sanitizer: DomSanitizer,
    private urlParser: UrlParserService,
  ) {
    const role = localStorage.getItem('userRole');
    this.teacherMode = role === 'teacher' ? true : false;

    this.teacherStatusOption = [
      { label: 'Pending', value: 'pending' },
      { label: 'Approved', value: 'approved' },
      { label: 'Declined', value: 'rejected' },
      { label: 'Completed', value: 'completed' },
    ];

    this.statusOptions = [
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
      { label: 'Pending', value: 'pending' },
    ];

    this.approveStatusOptions = [
      { label: 'Approve', value: 'Approve' },
      { label: 'Reject', value: 'Reject' },
    ];
  }

  private documentClickListener: (() => void) | null = null;

  ngOnInit(): void {
    const user = localStorage.getItem('userRole');
    this.isSuperAdmin = user === 'superadmin';
    if (user && user in userRoles) {
      this.userRoles =
        userRoles[user as keyof typeof userRoles]?.eventManagement;
      this.listViewRoles =
        userRoles[user as keyof typeof userRoles]?.eventManagementView;
    }

    this.route.queryParams.pipe(take(1)).subscribe((params) => {
      const tab = params['tab'];
      const page = params['page'] ? parseInt(params['page']) : 1;
      const view = params['view'];

      if (tab && ['admin', 'teacher', 'student', 'archived'].includes(tab)) {
        this.tableSegment = tab;
      } else {
        this.tableSegment = 'admin';
      }

      if (view === 'calendar') {
        this.eventViewMode = true;
      }

      this.currentPage = page;
      this.fetchEvents(this.tableSegment, this.currentPage);
    });

    this.route.queryParams.subscribe((params) => {
      this.eventViewMode = params['view'] === 'calendar';
    });

    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      this.viewMode = !!id;
      this.selectedSchoolID = id || null;
      if (this.viewMode && this.selectedSchoolID && !this.teacherMode) {
        this.fetchViewEvent(this.selectedSchoolID);
        this.fetchViewTable(this.selectedSchoolID, 'registrations');
        this.fetchEventStatus().subscribe();
        this.getEngagementMetrics(this.selectedSchoolID);
      } else if (this.viewMode && this.selectedSchoolID && this.teacherMode) {
        this.fetchViewEvent(this.selectedSchoolID);
        this.fetchTeacherEventStudents(this.selectedSchoolID);
        this.fetchStatusDD().subscribe();
        this.getEngagementMetrics(this.selectedSchoolID);
      }
    });

    this.searchControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((searchValue) => {
        this.search = searchValue || '';
        this.currentPage = 1;

        this.fetchEvents(this.tableSegment, this.currentPage);
      });
    // this.statusControl.valueChanges.subscribe(() => this.applyFilter());
    // this.eventTypeControl.valueChanges.subscribe(() => this.applyFilter());
    // this.locationControl.valueChanges.subscribe(() => this.applyFilter());

    if (this.Role == 'csquser') {
      this.teacherstudentadmincolumns = this.teacherstudentadmincolumns.filter(
        (item) => item !== 'media consent',
      );
      this.eventStudentsList = this.eventStudentsList.filter(
        (item) => item !== 'media consent',
      );
      this.teacherstudentHeldadmincolumns =
        this.teacherstudentHeldadmincolumns.filter(
          (item) => item !== 'media consent',
        );
      this.teacherstudentHeldColumns = this.teacherstudentHeldColumns.filter(
        (item) => item !== 'media consent',
      );
      this.teacherstudentcolumns = this.teacherstudentcolumns.filter(
        (item) => item !== 'media consent',
      );
      this.eventStudentsHeldList = this.eventStudentsHeldList.filter(
        (item) => item !== 'media consent',
      );
    }
  }

  applyFilter(): void {
    if (!this.viewMode) {
      return;
    }

    let filteredData = [...this.fullData];

    if (this.search && this.search.trim() !== '') {
      const searchTerm = this.search.toLowerCase().trim();
      filteredData = filteredData.filter((item) => {
        return Object.values(item).some((value) => {
          if (value && typeof value === 'object') {
            return Object.values(value).some((innerVal) =>
              innerVal?.toString().toLowerCase().includes(searchTerm),
            );
          }
          return value?.toString().toLowerCase().includes(searchTerm);
        });
      });
    }

    this.tableEvents = filteredData;
    this.resetPagination();
    this.cdr.detectChanges();
  }

  getExportApiUrl(): string {
    if (this.search) {
      return 'events/get/search/exports';
    } else {
      return 'events/get/allevents/exports';
    }
  }

  onExportClick(type: 'csv' | 'pdf' | 'excel'): void {}

  fetchEvents(tab?: string, page?: number): void {
    this.loading = true;
    this.tableLoading = true;
    const requestId = ++this.currentRequestId;

    let segment = tab || this.tableSegment;
    const pageToFetch = page || this.currentPage;

    const isArchived = segment === 'archived';
    const apiSegment = isArchived ? 'admin' : segment;

    let url: string;
    let isSearch = false;
    let currentParams: any = {
      type: segment,
      page: pageToFetch,
      orderby: 'desc',
      orderbyname: 'CreatedAt',
    };

    if (this.search && this.search.trim() !== '') {
      url = `events/get/search?type=${apiSegment}&search=${encodeURIComponent(this.search)}&page=${pageToFetch}`;
      if (isArchived) url += `&isDeleted=true`;
      else if (apiSegment === 'admin') url += `&isDeleted=false`;
      isSearch = true;
      currentParams.search = this.search;
      if (this.sortColumn && this.sortDirection) {
        const sortColumnName = this.getSortColumnName(this.sortColumn);
        url += `&orderby=${this.sortDirection}&orderbyname=${sortColumnName}`;
        currentParams.orderby = this.sortDirection;
        currentParams.orderbyname = sortColumnName;
      }
    } else {
      url = `events/get/allevents?type=${apiSegment}&page=${pageToFetch}`;
      if (isArchived) url += `&isDeleted=true`;
      else if (apiSegment === 'admin') url += `&isDeleted=false`;
      isSearch = false;
      if (this.sortColumn && this.sortDirection) {
        const sortColumnName = this.getSortColumnName(this.sortColumn);
        url += `&orderby=${this.sortDirection}&orderbyname=${sortColumnName}`;
        currentParams.orderby = this.sortDirection;
        currentParams.orderbyname = sortColumnName;
      }
    }

    this.currentExportParams = currentParams;
    this.isSearchExport = isSearch;

    this.httpService.get<any>(url).subscribe({
      next: (response) => {
        if (requestId !== this.currentRequestId) {
          return;
        }

        const items = response?.data?.items || [];
        this.totalRecords = response?.data?.totalRecord || 0;

        this.fullData = items.map((item: any) => {
          const startDate = item?.eventStartDate
            ? new Date(item.eventStartDate)
            : null;
          const endDate = item?.eventEndDate
            ? new Date(item.eventEndDate)
            : null;

          const formattedStartDate = startDate
            ? startDate.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              })
            : null;

          const formattedEndDate = endDate
            ? endDate.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              })
            : null;

          const formattedDate =
            formattedEndDate && formattedStartDate !== formattedEndDate
              ? `${formattedStartDate} - ${formattedEndDate}`
              : formattedStartDate;

          return {
            id: item.eventId,
            'event name': item.eventName || '-',
            'event type': item.eventTypeName || '-',
            'school': Array.isArray(item.schools) && item.schools.length > 0
              ? [...new Set(
                  item.schools.map((s: any) =>
                    typeof s === 'string' ? s : (s?.schoolName ?? s?.SchoolName ?? '')
                  )
                )].filter(Boolean).join(', ')
              : '-',
            '_schoolsList': Array.isArray(item.schools) && item.schools.length > 0
              ? [...new Set(
                  item.schools.map((s: any) =>
                    typeof s === 'string' ? s : (s?.schoolName ?? s?.SchoolName ?? '')
                  )
                )].filter(Boolean)
              : [],
            'Student name': item.studentName || '-',
            'approval status': item.eventAdminApprovalStatusName || '-',
            'teacher approval': item.eventTeacherApprovalStatusName || '-',
            'Teacher name': item.teacherName || '-',
            'number of students': item.studentCount || '0',
            date: item.eventStartDate
              ? (() => {
                  const format = (dt: string) => {
                    const [year, month, day] = dt.split('T')[0].split('-');
                    return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
                  };
                  const start = format(item.eventStartDate);
                  const end = item.eventEndDate
                    ? format(item.eventEndDate)
                    : null;
                  return end ? `${start} - ${end}` : start;
                })()
              : '-',
            'Date & time': {
              date: formattedDate,
              time: item?.eventTime,
            },
            location: item.location || '-',
            organiser:
              item.managers && item.managers.length > 0
                ? item.managers
                    .map((manager: any) =>
                      `${manager.firstName || ''} ${manager.lastName || ''}`.trim(),
                    )
                    .filter((name: string) => !!name)
                    .join(', ')
                : '-',
            'event managers':
              item.managers && item.managers.length > 0
                ? item.managers
                    .map((manager: any) =>
                      `${manager.firstName || ''} ${manager.lastName || ''}`.trim(),
                    )
                    .filter((name: string) => !!name)
                    .join(', ')
                : '-',
            eventDateRaw: item.eventStartDate || null,
            status: (() => {
              if (this.tableSegment === 'admin' || this.tableSegment === 'archived') {
                const label = this.normalizeCsqStatusLabel(item?.isDeleted ? 'Deleted' : item?.eventStatus);
                if (label.toLowerCase() === 'upcoming' && endDate && endDate < new Date()) {
                  return 'Already Held';
                }
                return label;
              }
              return item.eventAdminApprovalStatusName === 'Pending'
                ? 'Awaiting Approval'
                : item.eventAdminApprovalStatusName;
            })(),
            statusClass: (() => {
              if (this.tableSegment === 'admin' || this.tableSegment === 'archived') {
                const label = this.normalizeCsqStatusLabel(item?.isDeleted ? 'Deleted' : item?.eventStatus);
                const effectiveLabel = label.toLowerCase() === 'upcoming' && endDate && endDate < new Date()
                  ? 'Already Held'
                  : label;
                return this.getStatusClass(effectiveLabel);
              }
              return '';
            })(),
            imagePath: item.imagePath || null,
            isDraft: item?.isDraft ?? false,
            isDeleted: item?.isDeleted ?? false,
            createdBy: item?.createdBy ?? null,
          };
        });

        this.loading = false;
        this.tableLoading = false;
        this.tableEvents = [...this.fullData];
        this.currentPage = pageToFetch;
        this.cdr.detectChanges();
      },
      error: (err) => {
        if (requestId !== this.currentRequestId) return;

        console.error('Failed to load Events:', err);
        this.fullData = [];
        this.tableEvents = [];
        this.totalRecords = 0;
        this.loading = false;
        this.tableLoading = false;
        // A failed search degrades to an empty result ("No data available") instead of the red
        // error popup — only surface the toast for the non-search list load.
        if (!isSearch) {
          this.showErrorToast(err?.message);
        }
      },
    });
  }

  private getSortColumnName(column: string): string {
    const columnMapping: { [key: string]: string } = {
      'event name': 'EventName',
      'event type': 'EventType',
      date: 'EventStartDate',
      'date & time': 'EventStartDate',
      organizer: 'EventManagers',
      organiser: 'EventManagers',
      'event managers': 'EventManagers',
      location: 'Location',
      // Must track the status column's own value: admin/archived render eventStatus,
      // every other segment renders eventAdminApprovalStatusName.
      status:
        this.tableSegment === 'admin' || this.tableSegment === 'archived'
          ? 'EventStatus'
          : 'EventAdminApprovalStatusName',
      'approval status': 'EventAdminApprovalStatusName',
      'teacher approval': 'EventTeacherApprovalStatusName',
      'teacher name': 'TeacherName',
      'student name': 'StudentName',
      'number of students': 'StudentCount',
    };

    return columnMapping[column.toLowerCase()] || column;
  }

  private resetPagination(): void {
    this.tableEvents = [...this.tableEvents];
    if (this.tableComponent) {
      this.tableComponent.currentPage = 1;
      this.tableComponent.cdr?.detectChanges();
    }
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
    setTimeout(() => {
      if (this.viewMode && this.selectedSchoolID) {
        this.fetchChartData(this.selectedSchoolID);
      }
    }, 500);
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    this.stopAutoSlide();
    this.removeStatusDropdownClickListener();
  }

  toggleStatusDropdown(event: Event): void {
    event.stopPropagation();
    this.showStatusDropdown = !this.showStatusDropdown;
    if (this.showStatusDropdown) {
      this.addStatusDropdownClickListener();
    } else {
      this.removeStatusDropdownClickListener();
    }
    this.cdr.detectChanges();
  }

  getTeacherApprovalStatusLoadingText(): string {
    if (!this.pendingTeacherApprovalStatus) return 'Updating...';
    return this.pendingTeacherApprovalStatus === 'Approve'
      ? 'Approving...'
      : 'Rejecting...';
  }

  getAdminApprovalStatusLoadingText(): string {
    if (!this.pendingAdminApprovalStatus) return 'Updating...';
    return this.pendingAdminApprovalStatus === 'Approve'
      ? 'Approving...'
      : 'Rejecting...';
  }

  toggleApprovalStatusDropdown(event: Event): void {
    event.stopPropagation();
    if (this.teacherApprovalStatusLoading || this.adminApprovalStatusLoading) {
      return;
    }
    this.showApprovalStatusDropdown = !this.showApprovalStatusDropdown;
    if (this.showApprovalStatusDropdown) {
      if (!this.statusDropdownClickListener) {
        this.addStatusDropdownClickListener();
      }
    } else {
      this.removeStatusDropdownClickListener();
    }
    requestAnimationFrame(() => {
      this.cdr.detectChanges();
    });
  }

  closeStatusDropdown(): void {
    if (this.showStatusDropdown || this.showApprovalStatusDropdown) {
      this.showStatusDropdown = false;
      this.showApprovalStatusDropdown = false;
      this.removeStatusDropdownClickListener();
      this.cdr.markForCheck();
    }
  }

  private addStatusDropdownClickListener(): void {
    this.removeStatusDropdownClickListener();
    this.statusDropdownClickListener = () => {
      this.closeStatusDropdown();
    };
    setTimeout(() => {
      document.addEventListener('click', this.statusDropdownClickListener!);
    }, 0);
  }

  private removeStatusDropdownClickListener(): void {
    if (this.statusDropdownClickListener) {
      document.removeEventListener('click', this.statusDropdownClickListener);
      this.statusDropdownClickListener = null;
    }
  }

  getStatusClass(status: any): string {
    if (!status) return '';
    const normalizedStatus = String(status).trim().toLowerCase();
    switch (normalizedStatus) {
      case 'draft':
        return 'status-draft';
      case 'ongoing':
      case 'on today':
        return 'status-on-today';
      case 'upcoming':
        return 'status-upcoming';
      case 'already held':
      case 'alreadyheld':
      case 'completed':
      case 'event completed':
      case 'eventcompleted':
        return 'completed-text';
      case 'onhold':
      case 'on hold':
        return 'status-on-hold';
      case 'cancelled':
      case 'event cancelled':
      case 'eventcancelled':
      case 'deleted':
        return 'cancelled-text';
      default:
        return 'pending-text';
    }
  }

  getStatusOptionClass(status: any): string {
    return this.getStatusClass(status);
  }

  getApprovalStatusClass(
    status: any,
    isTeacherStatus: boolean = false,
  ): string {
    if (!status) return '';

    if (
      isTeacherStatus &&
      this.teacherApprovalStatusLoading &&
      this.teacherApprovalStatusLoadingText
    ) {
      return 'pending-text';
    }
    if (
      !isTeacherStatus &&
      this.adminApprovalStatusLoading &&
      this.adminApprovalStatusLoadingText
    ) {
      return 'pending-text';
    }

    const normalizedStatus = String(status).trim().toLowerCase();
    switch (normalizedStatus) {
      case 'approved':
        return 'active-text';
      case 'pending':
        return 'status-upcoming';
      case 'rejected':
        return 'cancelled-text';
      default:
        return '';
    }
  }

  getStatusDisplayValue(statusValue: any): string {
    if (!statusValue) return 'Pending';

    const statusArray = this.teacherMode
      ? this.teacherStatusOption
      : this.statusOptions;
    const status = statusArray.find(
      (opt) =>
        opt.value === statusValue ||
        opt.label === statusValue ||
        opt.id === statusValue,
    );

    return this.normalizeCsqStatusLabel(
      status?.label || statusValue || 'Pending',
    );
  }

  updateApprovalStatus(newStatus: any): void {
    if (this.studentViewEvent && this.Role === 'teacher') {
      this.teacherApprovalStatusLoading = true;
      this.teacherApprovalStatusLoadingText = true;
      this.pendingTeacherApprovalStatus = newStatus;
    } else {
      this.adminApprovalStatusLoading = true;
      this.adminApprovalStatusLoadingText = true;
      this.pendingAdminApprovalStatus = newStatus;
    }

    this.closeStatusDropdown();

    const statusValue =
      newStatus == 'Approve' ? true : newStatus == 'Reject' ? false : true;
    const endpoint =
      this.studentViewEvent && this.Role === 'teacher'
        ? `events/student-events/${this.selectedEvent.eventId}/teacher-approval?status=${statusValue}`
        : `events/student-events/${this.selectedEvent.eventId}/admin-approval?status=${statusValue}&&additionalComment=${''}`;

    this.httpService.put<APIResponse>(endpoint, '').subscribe({
      next: (response) => {
        if (response.status) {
          this.showSuccessToast(response?.message);

          if (this.studentViewEvent && this.Role === 'teacher') {
            this.selectedEvent.eventTeacherApprovalStatusName =
              newStatus === 'Approve'
                ? 'Approved'
                : newStatus === 'Reject'
                  ? 'Declined'
                  : 'Pending';
          } else {
            this.selectedEvent.eventAdminApprovalStatusName =
              newStatus === 'Approve'
                ? 'Approved'
                : newStatus === 'Reject'
                  ? 'Declined'
                  : 'Pending';
          }

          this.fetchViewEvent(this.selectedSchoolID);

          if (this.viewMode && this.selectedSchoolID && this.teacherMode) {
            this.fetchTeacherEventStudents(this.selectedSchoolID);
          } else {
            this.fetchViewTable(this.selectedSchoolID, 'registrations');
          }
        } else {
          this.showErrorToast(response?.message || 'Update failed');
        }
      },
      error: (error) => {
        console.error('Status update error:', error?.message);
        this.showErrorToast(
          error?.message || 'Something went wrong. Please try again later.',
        );
      },
      complete: () => {
        if (this.studentViewEvent && this.Role === 'teacher') {
          this.teacherApprovalStatusLoading = false;
          this.teacherApprovalStatusLoadingText = false;
          this.pendingTeacherApprovalStatus = null;
        } else {
          this.adminApprovalStatusLoading = false;
          this.adminApprovalStatusLoadingText = false;
          this.pendingAdminApprovalStatus = null;
        }
      },
    });
  }

  closeApprovalStatusDropdownImmediately(): void {
    this.showApprovalStatusDropdown = false;
    this.removeStatusDropdownClickListener();
    this.cdr.detectChanges();
  }

  updateEventStatus(newStatus: any): void {
    const eventStatusId = newStatus.value || newStatus;
    const statusLabel = this.normalizeCsqStatusLabel(
      newStatus?.label || newStatus?.name || newStatus,
    );
    const confirmationMessage =
      this.getStatusChangeConfirmationMessage(statusLabel);

    if (confirmationMessage) {
      this.closeStatusDropdown();
      this.confirmStatusChange(confirmationMessage, () => {
        this.approvalStatusLoading = true;
        this.submitEventStatusUpdate(
          `events/${this.selectedEvent.eventId}/internal-status?eventStatusId=${eventStatusId}`,
          eventStatusId,
          true,
        );
      });
      return;
    }

    this.approvalStatusLoading = true;
    this.submitEventStatusUpdate(
      `events/${this.selectedEvent.eventId}/internal-status?eventStatusId=${eventStatusId}`,
      eventStatusId,
      true,
    );
  }

  private getStatusChangeConfirmationMessage(
    statusLabel: string,
  ): string | null {
    const normalizedStatus = this.normalizeStatusKey(statusLabel);

    switch (normalizedStatus) {
      case 'cancelled':
        return 'Are you sure you want to cancel this event?';
      case 'completed':
        return 'Are you sure you want to complete this event?';
      case 'upcoming':
        return 'Are you sure you want to set this event to Upcoming?';
      case 'on today':
        return 'Are you sure you want to set this event to On Today?';
      case 'already held':
        return 'Are you sure you want to mark this event as Already Held?';
      case 'on hold':
        return 'Are you sure you want to put this event On Hold?';
      default:
        return `Are you sure you want to change the event status to ${statusLabel}?`;
    }
  }

  private confirmStatusChange(message: string, onConfirm: () => void): void {
    const dialogData: AlertDialogData = {
      title: 'Confirm status update',
      message,
      okText: 'Yes',
      cancelText: 'No',
      icon: 'warning',
      submessage: '',
      cancelButtonColor: '#EF4A00',
      okButtonColor: '#5BD763',
    };

    this.dialog
      .open(AlertDialogComponent, { width: '25.438rem', data: dialogData })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          onConfirm();
        }
      });
  }

  private submitEventStatusUpdate(
    endpoint: string,
    eventStatusId: any,
    allowFallback: boolean,
  ): void {
    this.httpService.put<APIResponse>(endpoint, '').subscribe({
      next: (response) => {
        if (response.status) {
          this.showSuccessToast(response?.message);
          this.fetchViewEvent(this.selectedSchoolID);
          this.fetchChartData(this.selectedSchoolID);
          this.closeStatusDropdown();
        } else {
          this.showErrorToast(
            response.message || 'Something went wrong. Please try again later.',
          );
        }

        this.loading = false;
        this.approvalStatusLoading = false;
      },
      error: (error) => {
        if (allowFallback && error?.status === 404) {
          this.submitEventStatusUpdate(
            `events/${this.selectedEvent.eventId}/toggle-status?eventStatusId=${eventStatusId}`,
            eventStatusId,
            false,
          );
          return;
        }

        console.error('Status update error:', error?.message);
        this.showErrorToast(
          error?.message || 'Something went wrong. Please try again later.',
        );
        this.loading = false;
        this.approvalStatusLoading = false;
      },
    });
  }

  fetchEventStatus() {
    return this.httpService.get<any>('events/event-statuses').pipe(
      tap({
        next: (response) => {
          if (Array.isArray(response.data)) {
            this.statusOptions = response.data.map((item: any) => ({
              label: this.normalizeCsqStatusLabel(item.name || item.label),
              value: item.id || item.value,
            }));
          } else {
            this.statusOptions = [];
            this.showErrorToast('Invalid status data format');
          }
        },
        error: (err) => {
          console.error('Failed to load event statuses:', err);
          this.statusOptions = [];
          this.showErrorToast(err?.message);
        },
      }),
    );
  }

  fetchStatusDD() {
    return this.httpService.get<any>(`teacherevent/event-statuses`).pipe(
      tap({
        next: (response) => {
          if (response.status && Array.isArray(response.data)) {
            this.teacherStatusOption = response.data.map((item: any) => ({
              label: item.name || item.label,
              value: item.id || item.value,
            }));
          } else {
            this.showErrorToast(
              'Something went wrong. Please try again later.',
            );
          }
        },
        error: (error) => {
          console.error('Teacher Status API Error:', error);
          this.showErrorToast(
            error?.message || 'Something went wrong. Please try again later.',
          );
        },
      }),
    );
  }

  prevSlide(): void {
    if (!this.selectedEvent?.imagePaths?.length) return;
    this.currentSlideIndex =
      (this.currentSlideIndex - 1 + this.selectedEvent.imagePaths.length) %
      this.selectedEvent.imagePaths.length;
    this.cdr.detectChanges();
  }

  nextSlide(): void {
    if (!this.selectedEvent?.imagePaths?.length) return;
    this.currentSlideIndex =
      (this.currentSlideIndex + 1) % this.selectedEvent.imagePaths.length;
    this.cdr.detectChanges();
  }

  goToSlide(index: number): void {
    if (!this.selectedEvent?.imagePaths?.length) return;
    this.currentSlideIndex = index;
    this.cdr.detectChanges();
  }

  startAutoSlide(): void {
    if (this.selectedEvent?.imagePaths?.length > 1) {
      this.stopAutoSlide();
      this.autoSlideInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    }
  }

  stopAutoSlide(): void {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = null;
    }
  }

  getImageUrl(imagePath: string): SafeUrl {
    if (!imagePath) {
      return 'assets/images/default-event.jpg';
    }
    if (imagePath.startsWith('http')) {
      return imagePath;
    }
    const baseUrl = 'https://your-api-base-url.com';
    const fullUrl = imagePath.startsWith('/')
      ? `${baseUrl}${imagePath}`
      : `${baseUrl}/${imagePath}`;
    return this.sanitizer.bypassSecurityTrustUrl(fullUrl);
  }

  handleImageError(event: any): void {
    console.error('Image failed to load:', event);
    event.target.src = 'assets/images/default-event.jpg';
  }

  initializeChart(): void {
    if (!this.chartContainer?.nativeElement) {
      setTimeout(() => this.initializeChart(), 100);
      return;
    }
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }

    const chartData = this.chartData || [];
    const dataPoints = chartData.map((item) => item.registrations);
    const categories = chartData.map((item) => item.date);

    const maxValue = Math.max(...dataPoints, 1);
    const minValue = 0;

    const options: ApexCharts.ApexOptions = {
      series: [
        {
          name: 'Registrations',
          data: dataPoints,
        },
      ],
      chart: {
        type: 'area',
        height: 250,
        toolbar: { show: false },
        zoom: { enabled: false },
        background: 'transparent',
        fontFamily: 'inherit',
        animations: {
          enabled: true,
          speed: 800,
        },
      },
      dataLabels: { enabled: false },
      stroke: {
        curve: 'smooth',
        width: 3,
        colors: ['#007BFF'],
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.6,
          opacityTo: 0.1,
          stops: [0, 90, 100],
          colorStops: [
            {
              offset: 0,
              color: '#007BFF',
              opacity: 0.6,
            },
            {
              offset: 100,
              color: '#1e3a5f',
              opacity: 0.1,
            },
          ],
        },
      },
      grid: {
        borderColor: 'rgba(255, 255, 255, 0.1)',
        strokeDashArray: 5,
        yaxis: { lines: { show: true } },
        xaxis: { lines: { show: false } },
        padding: { top: 0, right: 20, bottom: 0, left: 10 },
      },
      xaxis: {
        categories: categories,
        labels: {
          style: { colors: '#9CA3AF', fontSize: '12px' },
          rotate: 0,
          formatter: (value: string) => value,
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
        tooltip: { enabled: false },
      },
      yaxis: {
        labels: {
          style: { colors: '#9CA3AF', fontSize: '12px', fontWeight: 500 },
          formatter: (value: number) => Math.round(value).toString(),
        },
        min: 0,
        forceNiceScale: true,
      },
      tooltip: {
        enabled: true,
        theme: 'dark',
        x: { show: true, format: 'dd MMM yyyy' },
        y: {
          formatter: (value: number) =>
            `${value} registration${value !== 1 ? 's' : ''}`,
        },
        style: { fontSize: '12px' },
      },
    };

    try {
      this.chart = new ApexCharts(this.chartContainer.nativeElement, options);
      this.chart
        .render()
        .then(() => {
          this.chartInitialized = true;
          this.chartLoading = false;
          this.cdr.detectChanges();
        })
        .catch((error) => {
          console.error('Chart rendering failed:', error);
          this.chartLoading = false;
          this.cdr.detectChanges();
        });
    } catch (error) {
      console.error('Chart initialization failed:', error);
      this.chartLoading = false;
      this.cdr.detectChanges();
    }
  }

  updateChartData(newData: { date: string; registrations: number }[]): void {
    this.chartData = newData;

    if (this.chart && this.chartInitialized) {
      try {
        this.chart.updateOptions({
          xaxis: { categories: this.chartData.map((item) => item.date) },
          yaxis: {
            min: 0,
            max:
              Math.max(...this.chartData.map((item) => item.registrations), 1) *
              1.1,
          },
        });

        this.chart.updateSeries([
          {
            name: 'Registrations',
            data: this.chartData.map((item) => item.registrations),
          },
        ]);
      } catch (error) {
        console.error('Failed to update chart:', error);
        this.chart.destroy();
        this.chart = null;
        this.initializeChart();
      }
    } else {
      this.initializeChart();
    }
  }

  fetchChartData(eventId: string): void {
    this.chartLoading = true;
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }

    this.httpService
      .get<APIResponse>(`events/${eventId}/registration-over-time`)
      .subscribe({
        next: (response) => {
          if (
            response.data &&
            Array.isArray(response.data) &&
            response.data.length > 0
          ) {
            this.resChartData = response.data;
            this.updateChartWithRealData();
          } else {
            this.useDummyChartData();
          }
        },
        error: (error) => {
          console.error('Failed to load chart data:', error);
          this.useDummyChartData();
        },
        complete: () => {
          this.chartLoading = false;
        },
      });
  }

  updateChartWithRealData(): void {
    if (
      !this.resChartData ||
      !Array.isArray(this.resChartData) ||
      this.resChartData.length === 0
    ) {
      this.useDummyChartData();
      return;
    }

    const chartData = this.resChartData.map((item) => ({
      date: this.formatChartDate(item.date),
      registrations: item.registrations || 0,
    }));

    if (chartData.length === 1) {
      const singleDate = new Date(this.resChartData[0].date);
      const previousDate = new Date(singleDate);
      previousDate.setDate(previousDate.getDate() - 1);

      chartData.unshift({
        date: this.formatDateToChartFormat(previousDate),
        registrations: 0,
      });
    }

    this.updateChartData(chartData);
  }

  formatDateToChartFormat(date: Date): string {
    return date.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
    });
  }

  formatChartDate(dateString: string): string {
    if (!dateString) return '';

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return dateString.split('T')[0];
      }

      return date.toLocaleDateString('en-US', {
        day: '2-digit',
        month: 'short',
      });
    } catch (error) {
      console.error('Error formatting date:', error, dateString);
      return dateString.split('T')[0];
    }
  }

  fetchViewEventGraph(id: string): void {
    if (!id) {
      return;
    }

    this.httpService
      .get<APIResponse>(`events/${id}/registration-over-time`)
      .subscribe({
        next: (response) => {
          if (
            response.data &&
            Array.isArray(response.data) &&
            response.data.length > 0
          ) {
            this.resChartData = response.data;
            this.updateChartWithRealData();
          } else {
            this.resChartData = null;
            this.useDummyChartData();
          }
        },
        error: (err) => {
          this.resChartData = null;
          this.useDummyChartData();
          this.showErrorToast(err?.message);
        },
        complete: () => (this.loading = false),
      });
  }

  useDummyChartData(): void {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const dummyData = [
      { date: this.formatDateToChartFormat(yesterday), registrations: 0 },
      { date: this.formatDateToChartFormat(today), registrations: 0 },
    ];

    this.updateChartData(dummyData);
  }

  fetchStatusList() {
    this.loading = true;
    // this.tableLoading = true;
    return this.httpService.get<APIResponse>('events/event-statuses').pipe(
      tap({
        next: (response) => {
          this.statusOptions = Array.isArray(response?.data)
            ? response.data.map((item) => ({
                value: item.id,
                label: item.name,
              }))
            : [];
        },
        error: (err) => {},
        complete: () => {
          this.loading = false;
          // this.tableLoading = false;
        },
      }),
    );
  }

  fetchViewEvent(id: string): void {
    this.pageloading = true;
    if (!id) {
      this.pageloading = false;
      return;
    }
    this.httpService.get<APIResponse>(`events/${id}`).subscribe({
      next: (response) => {
        if (response.data && !Array.isArray(response.data)) {
          let imagePaths: string[] = [];
          this.isInternal =
            response.data['eventTypeScopeName'] == 'External' ? true : false;

          if (
            response.data['imagePaths'] &&
            Array.isArray(response.data['imagePaths'])
          ) {
            imagePaths = response.data['imagePaths'];
          } else if (
            response.data['images'] &&
            Array.isArray(response.data['images'])
          ) {
            imagePaths = response.data['images'];
          } else if (response.data['imagePath']) {
            imagePaths = [response.data['imagePath']];
          } else if (
            response.data['eventImages'] &&
            Array.isArray(response.data['eventImages'])
          ) {
            imagePaths = response.data['eventImages'].map(
              (img: any) => img.url || img.path,
            );
          }

          imagePaths = imagePaths.filter((path) => path && path.trim() !== '');

          // this.selectedEvent = {
          //     ...response.data,
          //     imagePaths: imagePaths,
          // };
          // imagePaths = [
          //     'https://images.pexels.com/photos/414612/pexels-photo-414612.jpeg',
          //     'https://images.pexels.com/photos/1103970/pexels-photo-1103970.jpeg',
          //     'https://images.pexels.com/photos/34950/pexels-photo.jpg',
          //     'https://images.pexels.com/photos/736230/pexels-photo-736230.jpeg',
          //     'https://images.pexels.com/photos/417173/pexels-photo-417173.jpeg',
          //     'https://images.pexels.com/photos/709552/pexels-photo-709552.jpeg',
          //     'https://images.pexels.com/photos/248797/pexels-photo-248797.jpeg',
          //     'https://images.pexels.com/photos/462118/pexels-photo-462118.jpeg'
          // ]

          // console.log(response,"dsfjksdbjfksdbfjkbsd");
          let item = response.data;
          this.studentEventView =
            response.data?.['eventTypeName'] == 'Student External Event';
          this.selectedEvent = {
            ...response.data,
            imagePaths: imagePaths,
            eventStatus: item?.['isDeleted']
              ? 'Deleted'
              : !item?.['isDraft'] && item?.['eventStatus'] == 'Draft'
                ? 'Upcoming'
                : item?.['isDraft']
                  ? 'Draft'
                  : this.normalizeCsqStatusLabel(
                      item?.['eventStatus'] ?? 'Active',
                    ),
            // status: (!item?.isDraft && item.eventStatus == 'Draft') ? 'Upcoming' : item?.isDraft ? "Draft" : item.eventStatus ?? 'Active',
          };

          if (response.data) {
            const role = response.data?.['createdByRole']
              ?.toLowerCase()
              ?.trim();
            console.log(role);
            console.log(response.data);
            this.adminViewEvent =
              role === 'csq admin' ||
              role === 'super admin' ||
              role === 'csq user';
            this.teacherViewEvent = role === 'teacher';
            this.studentViewEvent = role === 'student';
          }
          this.eventViewFTCH = true;

          this.selectedStatus = response.data['status'] ?? null;
          this.currentSlideIndex = 0;
          this.isEventHeld = this.selectedEvent?.eventStatus === 'Already Held';
          if (this.selectedEvent.imagePaths.length > 1) {
            this.startAutoSlide();
          }
        } else {
          this.selectedEvent = null;
          this.showErrorToast('Event data not found');
        }
        this.pageloading = false;
      },
      error: (err) => {
        console.error('Failed to load event details:', err);
        this.selectedEvent = null;
        this.showErrorToast(err?.message);
        this.pageloading = false;
      },
      complete: () => {
        this.loading = false;
        this.pageloading = false;
      },
    });
  }

  fetchTeacherEventStudents(id: string): void {
    this.teacherloading = true;
    if (!id) {
      return;
    }
    this.httpService
      .get<APIResponse>(`teacherevent/${id}/registrations`)
      .subscribe({
        next: (response) => {
          if (response.data && Array.isArray(response.data)) {
            this.teacherStudentData = Array.isArray(response?.data)
              ? response.data.map((item) => {
                  let status = item?.registrationStatus
                    ? item?.registrationStatus
                    : 'Pending';
                  return {
                    id: item.registrationId,
                    'student name': item.studentName || '',
                    'approval status': item.registrationStatus,
                    adminStatus: item?.adminApprovalStatus,
                    teacherStatus: item?.teacherApprovalStatus,
                    attended: item.isAttended ?? false,
                    // 'PD points': item.isAttended ? item.pdPoints : null,
                    'PD points': item.isAttended ? item.pdPoints : '-',
                    'media consent': item.isMediaConsentApproved
                      ? item?.isMediaConsentApproved
                      : 'Pending',
                    notes: item.notes || '',
                    'school name': item.schoolName || '',
                    status: status,
                    isStatusClickable:
                      status == 'TeacherReviewPending' ||
                      status == 'Interested',
                  };
                })
              : [];
          } else {
            this.teacherStudentData = [];
            this.showErrorToast('Event data not found');
          }
        },
        error: (err) => {
          console.error('Failed to load event details:', err);
          this.teacherStudentData = [];
          this.showErrorToast(err?.message);
          this.teacherloading = false;
        },
        complete: () => (this.teacherloading = false),
      });
  }

  fetchViewTable(id: string, type: string): void {
    this.studentTabelLoading = true;
    const endpoint =
      type === 'students'
        ? 'students'
        : type === 'teachers'
          ? 'teachers'
          : type === 'registrations'
            ? 'registrations'
            : 'contacts';

    this.httpService.get<APIResponse>(`events/${id}/${endpoint}`).subscribe({
      next: (response) => {
        if (type === 'students') {
          this.studentData = Array.isArray(response?.data)
            ? response.data.map((student) => ({
                id: student.studentId || '-',
                studentName: student.studentName || '-',
                email: student.email || '-',
                department: student.department || '-',
                registrationDate: student.registrationDate || '-',
              }))
            : [];
        } else if (type === 'teachers') {
          this.teacherData = Array.isArray(response?.data)
            ? response.data.map((teacher) => ({
                id: teacher.teacherId || '-',
                teacherName: teacher.teacherName || '-',
                email: teacher.email || '-',
                phoneNumber: teacher.phoneNumber || '-',
              }))
            : [];
        } else if (type === 'contacts') {
          this.contactData = Array.isArray(response?.data)
            ? response.data.map((contact) => ({
                id: contact.contactId || '-',
                name: contact.name || '-',
                email: contact.email || '-',
                phoneNumber: contact.phoneNumber || '-',
                position: contact.position || '-',
              }))
            : [];
        } else if (type === 'registrations') {
          this.eventStudentList = Array.isArray(response?.data)
            ? response.data.map((item) => ({
                id: item.registrationId,
                'student name': item.studentName || '',
                'approval status': item.teacherApprovalStatus
                  ? 'Approved'
                  : 'Declined',
                attended: item.isAttended ?? false,
                // 'PD points': item.isAttended ? item.pdPoints : null,
                'PD points': item.isAttended ? item.pdPoints : '-',
                'media consent': item.isMediaConsentApproved
                  ? item?.isMediaConsentApproved
                  : 'Pending',
                notes: item.notes || '',
                'school name': item.schoolName || '',
                adminStatus: item?.adminApprovalStatus,
                teacherStatus: item?.teacherApprovalStatus,
                status:
                  item.adminApprovalStatus &&
                  item?.registrationStatus == 'TeacherApproved'
                    ? 'Registered'
                    : item?.registrationStatus
                      ? item?.registrationStatus
                      : 'Pending',
              }))
            : [];
        }
      },
      error: (err) => {
        console.error(`Failed to load ${type}:`, err);
        if (type === 'students') this.studentData = [];
        if (type === 'teachers') this.teacherData = [];
        if (type === 'contacts') this.contactData = [];
        if (type === 'registrations') this.eventStudentList = [];
        this.showErrorToast(`Something went wrong. Please try again later.`);
      },
      complete: () => (this.studentTabelLoading = false),
    });
  }

  onSort(event: {
    direction: 'asc' | 'desc' | '';
    column: string | null;
  }): void {
    this.sortColumn = event.column;
    this.sortDirection = event.direction;
    this.currentPage = 1;
    this.updateUrlWithPage(this.currentPage);
    this.fetchEvents(this.tableSegment, this.currentPage);
  }

  private updateUrlWithPage(page: number): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        tab: this.tableSegment,
        page: page,
      },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  onPageChange(page: number): void {
    if (page === this.currentPage) return;

    this.currentPage = page;
    this.updateUrlWithPage(page);
    this.fetchEvents(this.tableSegment, page);
  }

  toggleTabs(tab: string): void {
    if (tab === this.tableSegment) return;

    this.tableSegment = tab;
    this.currentPage = 1;
    this.sortColumn = null;
    this.sortDirection = '';
    this.router
      .navigate([], {
        relativeTo: this.route,
        queryParams: {
          tab: tab,
          page: 1,
        },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      })
      .then(() => {
        this.fetchEvents(tab, 1);
      });
  }

  onStatusClick(
    event: { row: any; id: any },
    type: boolean,
    status?: boolean,
  ): void {
    if (!this.userRoles?.listItem?.statusChange) return;
    const { row, id } = event;
    if (
      this.tableSegment === 'student' &&
      row['teacher approval'] !== 'Approved'
    )
      return;
    const currentStatus = row['approval status'];
    const newStatus =
      currentStatus === 'Pending'
        ? true
        : currentStatus === 'Approved'
          ? false
          : true;

    const dialogData: AlertDialogData = {
      title: 'Change approval status?',
      message:
        currentStatus === 'Pending'
          ? 'Do you want to mark this work experience as Approve or Decline?'
          : `Do you want to mark this work experience as ${currentStatus === 'Declined' ? 'Approved' : 'Declined'}?`,
      okText:
        currentStatus === 'Pending' || currentStatus === 'Declined'
          ? 'Approve'
          : 'Reject',
      cancelText: currentStatus === 'Pending' ? 'Reject' : 'Cancel',
      icon: 'warning',
      submessage: '',
      cancelButtonColor: currentStatus === 'Pending' ? '#EF4A00' : '',
      okButtonColor:
        currentStatus === 'Pending' || currentStatus === 'Declined'
          ? '#5BD763'
          : '',
    };

    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '25.438rem',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result || result?.status) {
        if (type) {
          const payload = {
            status: 'approved',
            reason: null,
          };

          this.httpService
            .put<APIResponse>(`teacherevent/${id}/approval`, payload)
            .subscribe({
              next: (response) => {
                if (response?.status) {
                  this.fetchEvents();
                  this.showSuccessToast(response.message);
                } else {
                  this.showErrorToast(response.message);
                }
              },
              error: (err) => {
                this.showErrorToast(err?.message);
              },
            });
        } else {
          this.httpService
            .put<APIResponse>(
              this.tableSegment === 'student'
                ? `events/student-events/${id}/admin-approval?status=${result?.action == 'Reject' ? result?.status : newStatus}&&additionalComment=${''}`
                : `events/event-approval/${id}?status=${result?.action == 'Reject' ? result?.status : newStatus}&&additionalComment=${''}`,
              {},
            )
            .subscribe({
              next: (response) => {
                if (response?.status) {
                  this.fetchEvents();
                  this.showSuccessToast(response.message);
                } else {
                  this.showErrorToast(response.message);
                }
              },
              error: (err) => {
                this.showErrorToast(err?.message);
              },
            });
        }
      } else if (!result && type) {
        const payload = {
          status: 'rejected',
          reason: null,
        };

        this.httpService
          .put<APIResponse>(`teacherevent/${id}/approval`, payload)
          .subscribe({
            next: (response) => {
              if (response?.status) {
                if (!type) {
                  this.fetchEvents();
                  this.showSuccessToast(response.message);
                } else {
                  this.fetchTeacherEventStudents(this.selectedSchoolID);
                }
              } else {
                this.showErrorToast(response.message);
              }
            },
            error: (err) => {
              this.showErrorToast(err?.message);
            },
          });
      }
    });
  }

  teacherApprovalStatusClick(event: { row: any; id: any }): void {
    const { row, id } = event;
    if (row.status !== 'TeacherReviewPending' && row.status !== 'Interested')
      return;

    const dialogData: AlertDialogData = {
      title: 'Change approval status? ',
      message: 'Do you want to mark this student Approved or Rejected?',
      okText: 'Approve',
      cancelText: 'Reject',
      icon: 'warning',
      submessage: '',
      cancelButtonColor: '#EF4A00',
      okButtonColor: '#5BD763',
    };

    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '25.438rem',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        const status = result;
        this.httpService
          .get<APIResponse>(
            `studenteventregistrations/teacher-approve/${id}?approved=${status}`,
          )
          .subscribe({
            next: (response) => {
              if (response?.status) {
                this.fetchTeacherEventStudents(this.selectedSchoolID);
                this.showSuccessToast(response.message);
              } else {
                this.showErrorToast(response.message);
              }
            },
            error: (err) => {
              this.showErrorToast(err?.message);
            },
          });
      }
    });
  }

  isPdf() {
    if (!this.selectedEvent?.imagePaths[0]) return false;
    return this.selectedEvent?.imagePaths[0].toLowerCase().endsWith('.pdf');
  }

  getEventImage(): boolean {
    if (
      this.selectedEvent?.imagePaths &&
      this.selectedEvent.imagePaths.length > 0
    ) {
      return true;
      // this.eventData.imagePaths[0];
    }
    return false;
  }

  async downloadFiles() {
    if (!this.selectedEvent?.imagePaths?.length) {
      this.showErrorToast('Something went wrong');
      // this.updateRowDownloadingState(row.id, false);
      return;
    }

    let url = this.selectedEvent?.imagePaths[0];
    console.log(url);
    if (this.isPdf()) {
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.download = `student-evidence-document`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      this.showEventModal = this.selectedEvent?.imagePaths[0];
    }

    // const zip = new JSZip();

    // const downloadTasks = this.selectedEvent?.imagePaths.map(async (url :any, index : any) => {
    //     const response = await fetch(url);
    //     const blob = await response.blob();

    //     // Detect file extension
    //     let extension = 'file';
    //     const contentType = blob.type;

    //     if (contentType.includes('pdf')) {
    //         extension = 'pdf';
    //     } else if (contentType.includes('jpeg')) {
    //         extension = 'jpg';
    //     } else if (contentType.includes('png')) {
    //         extension = 'png';
    //     } else if (contentType.includes('webp')) {
    //         extension = 'webp';
    //     }
    //     zip.file(`document-${index + 1}.${extension}`, blob);
    // });

    // try {
    //     await Promise.all(downloadTasks);

    //     const zipBlob = await zip.generateAsync({ type: 'blob' });

    //     const link = document.createElement('a');
    //     link.href = URL.createObjectURL(zipBlob);
    //     link.download = 'event-files.zip';
    //     link.click();
    //     URL.revokeObjectURL(link.href);
    // } catch (error : any) {
    //     this.showErrorToast(error.message ||"Something went wrong")
    // }
  }

  closeEventModal() {
    this.showEventModal = false;
  }

  logStatus(status: any): string {
    return status || 'Active';
  }

  toggleShow() {
    this.isExpanded = !this.isExpanded;
  }

  eventView() {
    this.eventViewMode = !this.eventViewMode;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { view: this.eventViewMode ? 'calendar' : null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  updateSearch(searchValue: string): void {
    this.search = searchValue;
    this.searchControl.setValue(searchValue);
    this.cdr.detectChanges();
  }

  switchSegment(segment: 'teachers' | 'students' | 'contacts') {
    this.selectedSegment = segment;
    this.fetchViewTable(this.selectedSchoolID, this.selectedSegment);
  }

  openAddDialog(
    schoolToEdit: any = null,
    isEdit: boolean = false,
    width: string = '54.5rem',
  ): void {
    const dialogRef = this.dialog.open(AddEventComponent, {
      width: width,
      maxWidth: '90vw',
      minWidth: '300px',
      data: { initialData: schoolToEdit, EditMode: isEdit },
      disableClose: true,
      autoFocus: false,

      panelClass: 'custom-dialog-container',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        if (!this.viewMode) {
          this.fetchEvents();
        } else {
          if (this.viewMode && result?.value?.eventId) {
            this.router.navigate([
              '/events/event-list/view',
              result?.value?.eventId,
            ]);
            this.fetchViewEvent(this.selectedSchoolID);
            this.fetchChartData(this.selectedSchoolID);
          }
        }
      }
    });
  }

  openStatusDialog(width: string = '38rem') {
    this.comments = '';
    const dialogRef = this.dialog.open(CommonDialogComponent, {
      data: {
        title: 'Set Event Status',
        confirmText: 'Submit',
        cancelText: 'Cancel',
        template: this.statusUpdateContent,
      },
      width,
      maxWidth: '100vw',
      disableClose: true,
      autoFocus: false,
    });

    dialogRef.componentInstance.confirmed.subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.onSubmit();
      }
    });
  }

  onSubmit() {
    const payload = {
      eventId: this.selectedEvent?.id || this.selectedSchoolID,
      status: this.selectedStatus,
      additionalComments: this.comments,
      approvedBy: 'a4bcc6ab-1566-f011-8f7c-002248108b20',
      approvedDate: new Date().toISOString(),
    };

    this.httpService
      .put<APIResponse>('events/update-status', payload)
      .subscribe({
        next: (response) => {
          if (response.status) {
            this.showSuccessToast('Status updated successfully!');
            this.fetchViewEvent(this.selectedSchoolID);
          } else {
            this.showErrorToast(response.message);
          }
        },
        error: (error) => {
          console.error('Status update failed:', error);
          this.showErrorToast('Something went wrong. Please try again later.');
        },
        complete: () => this.dialog.closeAll(),
      });
  }

  openSendEmail(width = '50.5rem', initialData?: {}): void {
    const dialogConfig: MatDialogConfig<any> = {
      width: width,
      maxWidth: '90vw',
      minWidth: '300px',
      data: {
        initialData: {
          ...initialData,
          fromEmail: this.selectedEvent?.managers[0]?.email,
          ccEmail: ['constructionpathways@gmail.com'],
          id: this.selectedEvent?.eventId,
        },
        eventData: this.selectedEvent,
      },
      disableClose: true,
      autoFocus: false,
      backdropClass: 'blur-backdrop',
      hasBackdrop: true,
      panelClass: 'blur-backdrop-dialog',
    };

    try {
      const dialogRef = this.dialog.open(
        SendEmailDialogComponent,
        dialogConfig,
      );

      dialogRef.afterClosed().subscribe((result) => {
        if (result?.success) {
        }
      });
    } catch (error) {
      console.error('Error opening dialog:', error);
    }
  }

  openAddTeacherDialog(
    teacherToEdit: APIResponse | undefined = undefined,
    isEdit: boolean = false,
    width: string = '50.5rem',
  ) {
    const dialogConfig: MatDialogConfig<TeacherDialogData> = {
      width: width,
      maxWidth: '90vw',
      minWidth: '300px',
      data: {
        initialData: teacherToEdit,
        EditMode: isEdit,
        schoolID: this.selectedSchoolID,
        ViewMode: false,
      },
      disableClose: true,
      autoFocus: false,
      panelClass: 'custom-dialog-container',
    };

    const dialogRef = this.dialog.open(AddTeacherComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.fetchViewTable(this.selectedSchoolID, this.selectedSegment);
      }
    });
  }

  openAddStudentDialog(
    teacherToEdit: APIResponse | undefined = undefined,
    isEdit = false,
    width = '50.5rem',
  ): void {
    const schoolID =
      teacherToEdit &&
      typeof teacherToEdit === 'object' &&
      'schools' in teacherToEdit
        ? (teacherToEdit as any)?.schools?.[0]?.schoolId
        : this.selectedSchoolID;

    const dialogConfig: MatDialogConfig<TeacherDialogData> = {
      width,
      maxWidth: '90vw',
      minWidth: '300px',
      data: {
        initialData: teacherToEdit,
        EditMode: isEdit,
        schoolID: '',
        eventId: this.selectedEvent.eventId,
        addStudent: true,
        ViewMode: false,
      },
      disableClose: true,
      autoFocus: false,
      panelClass: 'custom-dialog-container',
    };

    this.dialog
      .open(AddStudentComponent, dialogConfig)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          if (this.viewMode && this.selectedSchoolID && !this.teacherMode) {
            this.fetchViewTable(this.selectedSchoolID, 'registrations');
            this.getEngagementMetrics(this.selectedSchoolID);
          } else if (
            this.viewMode &&
            this.selectedSchoolID &&
            this.teacherMode
          ) {
            this.fetchTeacherEventStudents(this.selectedSchoolID);
            this.getEngagementMetrics(this.selectedSchoolID);
          }
        }
      });
  }

  onDelete(row: any): void {
    const dialogData: AlertDialogData = {
      title: 'Confirm delete',
      message: `Are you sure want to delete?`,
      okText: 'Delete',
      cancelText: 'Cancel',
      icon: 'warning',
      submessage: '',
    };

    this.dialog
      .open(AlertDialogComponent, { width: '25.438rem', data: dialogData })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.httpService
            .delete<APIResponse>(`events/${row.id}/internal-delete`)
            .subscribe({
              next: (response) => {
                if (response.status) {
                  if (
                    this.Role === 'superadmin' &&
                    this.tableSegment === 'admin'
                  ) {
                    row.status = 'Deleted';
                    row.eventStatus = 'Deleted';
                    row.isDeleted = true;
                    row.statusClass = this.getStatusClass('Deleted');

                    if (this.selectedEvent?.eventId === row.id) {
                      this.selectedEvent = {
                        ...this.selectedEvent,
                        eventStatus: 'Deleted',
                        isDeleted: true,
                      };
                    }

                    this.tableEvents = [...this.tableEvents];
                  } else {
                    this.tableEvents = this.tableEvents.filter(
                      (s: { id: any }) => s.id !== row.id,
                    );
                    this.adjustPaginationAfterDelete();
                  }
                  this.showSuccessToast(response.message);
                } else {
                  this.showErrorToast(response.message);
                }
              },
              error: (err) =>
                this.showErrorToast(
                  err?.message ||
                    `Something went wrong. Please try again later.`,
                ),
            });
        }
      });
  }

  private adjustPaginationAfterDelete(): void {
    const totalPages = Math.ceil(
      this.tableEvents.length / (this.tableComponent?.pageSize || 10),
    );
    if (
      this.tableComponent &&
      this.tableComponent.currentPage > totalPages &&
      totalPages > 0
    ) {
      this.tableComponent.currentPage = totalPages;
    }
  }

  openAddContactDialog(
    contactToEdit: APIResponse | undefined = undefined,
    isEdit: boolean = false,
    width: string = '50.5rem',
    view: boolean = false,
  ): void {
    const dialogConfig: MatDialogConfig<TeacherDialogData> = {
      width,
      maxWidth: '90vw',
      minWidth: '300px',
      data: {
        initialData: contactToEdit,
        EditMode: isEdit,
        schoolID: this.selectedSchoolID,
        ViewMode: view,
      },
      disableClose: true,
      autoFocus: false,
      panelClass: 'custom-dialog-container',
    };

    try {
      const dialogRef = this.dialog.open(ContactDialogComponent, dialogConfig);

      dialogRef.afterClosed().subscribe({
        next: (result) => {
          if (result) {
            this.fetchViewTable(this.selectedSchoolID, 'contacts');
          }
        },
        error: (err) => {
          console.error('Error in dialog afterClosed:', err);
          this.showErrorToast('Something went wrong. Please try again later.');
        },
      });
    } catch (err) {
      console.error('Failed to open contact dialog:', err);
      this.showErrorToast('Something went wrong. Please try again later.');
    }
  }

  syncAsana(): void {
    if (this.syncLoading) return;

    this.syncLoading = true;
    this.httpService
      .post(`events/${this.selectedEvent.eventId}/sync-asana`, {})
      .pipe(
        tap({
          next: (res: any) => {
            this.syncLoading = false;
            if (res?.status) {
              this.showSuccessToast(
                res?.message || 'Synced with Asana successfully',
              );
              this.fetchViewEvent(this.selectedSchoolID);
            } else {
              this.showErrorToast(
                res?.message || 'Something went wrong. Please try again later.',
              );
            }
          },
          error: (error) => {
            this.syncLoading = false;
            this.showErrorToast(
              error?.message || 'Something went wrong. Please try again later.',
            );
          },
        }),
      )
      .subscribe();
  }

  shareStudent(): void {
    if (this.shareLoading) return;

    this.shareLoading = true;
    this.httpService
      .post(`teacherevent/share/${this.selectedEvent.eventId}`, {})
      .pipe(
        tap({
          next: (res: any) => {
            this.shareLoading = false;
            if (res?.status) {
              this.showSuccessToast(res?.message);
            } else {
              this.showErrorToast(res?.message);
            }
          },
          error: (error) => {
            this.shareLoading = false;
            this.showErrorToast(error?.message);
          },
        }),
      )
      .subscribe();
  }

  getFocusAreaNames(): string {
    return (
      this.selectedEvent?.focusAreas
        ?.map((area: any) => area.focusAreaName)
        .join(', ') || '-'
    );
  }

  getManagersNames(): string {
    return (
      this.selectedEvent?.managers
        ?.map((manger: any) => manger.firstName + ' ' + manger.lastName)
        .join(', ') || '-'
    );
  }

  getMCCpartnersNames(): string {
    return (
      this.selectedEvent?.mccPartners
        ?.map((manger: any) => manger.mccEventPartnerName)
        .join(', ') || '-'
    );
  }

  onEdit(event: any): void {
    if (this.isEditInProgress) {
      return;
    }

    this.isEditInProgress = true;
    if (event.id) {
      this.httpService.get<APIResponse>(`events/${event.id}`).subscribe({
        next: (response) => {
          if (response.data && !Array.isArray(response.data)) {
            this.isEditInProgress = false;
            let imagePaths: string[] = [];
            this.isInternal =
              response.data['eventTypeScopeName'] == 'External' ? true : false;

            if (
              response.data['imagePaths'] &&
              Array.isArray(response.data['imagePaths'])
            ) {
              imagePaths = response.data['imagePaths'];
            } else if (
              response.data['images'] &&
              Array.isArray(response.data['images'])
            ) {
              imagePaths = response.data['images'];
            } else if (response.data['imagePath']) {
              imagePaths = [response.data['imagePath']];
            } else if (
              response.data['eventImages'] &&
              Array.isArray(response.data['eventImages'])
            ) {
              imagePaths = response.data['eventImages'].map(
                (img: any) => img.url || img.path,
              );
            }

            imagePaths = imagePaths.filter(
              (path) => path && path.trim() !== '',
            );

            const eventData = {
              ...response.data,
              imagePaths: imagePaths,
            };

            this.openAddDialog(eventData, true);
          } else {
            this.showErrorToast('Event data not found');
            this.isEditInProgress = false;
          }
        },
        error: (err) => {
          console.error('Failed to load event details:', err);
          this.showErrorToast(err?.message);
          this.isEditInProgress = false;
        },
        complete: () => {
          ((this.loading = false), (this.isEditInProgress = false));
        },
      });
    } else {
      this.openAddDialog(this.selectedEvent, true);
      this.isEditInProgress = false;
    }
  }

  canEditEvent(event: any): boolean {
    if (
      !event ||
      (this.tableSegment !== 'admin' && this.tableSegment !== 'archived')
    ) {
      return false;
    }

    const normalizedStatus = this.normalizeStatusKey(
      event.eventStatus || event.status,
    );
    if (normalizedStatus === 'deleted' || event?.isDeleted) {
      return this.Role === 'superadmin';
    }

    if (
      normalizedStatus === 'completed' ||
      normalizedStatus === 'event completed'
    ) {
      return this.Role === 'superadmin';
    }

    return (
      this.Role === 'superadmin' ||
      this.Role === 'csqadmin' ||
      this.Role === 'csquser'
    );
  }

  canDeleteEvent(event: any): boolean {
    if (!event || this.tableSegment !== 'admin') {
      return false;
    }

    const normalizedStatus = this.normalizeStatusKey(
      event.eventStatus || event.status,
    );
    if (normalizedStatus !== 'draft') {
      return false;
    }

    if (this.Role === 'csquser') {
      const currentUserId = this.getCurrentUserId();
      return !!currentUserId && event?.createdBy === 'CSQ User';
    }

    return this.Role === 'superadmin' || this.Role === 'csqadmin';
  }

  canChangeSelectedEventStatus(): boolean {
    if (!this.selectedEvent || this.tableSegment !== 'admin') {
      return false;
    }

    const normalizedStatus = this.normalizeStatusKey(
      this.selectedEvent?.eventStatus,
    );

    if (normalizedStatus === 'draft' || normalizedStatus === 'deleted') {
      return false;
    }

    if (
      normalizedStatus === 'completed' ||
      normalizedStatus === 'event completed'
    ) {
      return this.Role === 'superadmin';
    }

    return (
      this.Role === 'superadmin' ||
      this.Role === 'csqadmin' ||
      this.Role === 'csquser'
    );
  }

  private getCurrentUserId(): string | null {
    try {
      const userDetails = localStorage.getItem('userDetails');
      return userDetails ? (JSON.parse(userDetails)?.userId ?? null) : null;
    } catch {
      return null;
    }
  }

  private normalizeCsqStatusLabel(status: any): string {
    const normalizedStatus = this.normalizeStatusKey(status);

    switch (normalizedStatus) {
      case 'ongoing':
        return 'On Today';
      case 'completed':
      case 'event completed':
        return 'Completed';
      case 'cancelled':
      case 'event cancelled':
        return 'Cancelled';
      default:
        return status || 'Pending';
    }
  }

  private normalizeStatusKey(status: any): string {
    return String(status || '')
      .trim()
      .toLowerCase();
  }

  onView(row: any): void {
    const encodedId = this.urlParser.encodeId(row.id.toString());
    const viewSegment =
      this.tableSegment === 'archived' ? 'admin' : this.tableSegment;
    const encodedSegment = this.urlParser.encodeId(viewSegment);

    this.router.navigate(['/events/event-list/view', encodedId], {
      queryParams: { segment: encodedSegment },
    });
  }

  goBack() {
    if (this.eventViewMode) {
      this.eventView();
    } else {
      this.location.back();
    }
  }

  onToggleChange(event: { row: any; checked: boolean }): void {
    const { row, checked } = event;
    const originalState = row.attended;
    row.attended = originalState;
    this.cdr.detectChanges();

    const dialogData: AlertDialogData = {
      title: 'Confirm attendance update',
      message: checked
        ? 'Do you want to mark this student as Attended?'
        : 'Do you want to mark this student as Not Attended?',
      okText: 'Yes',
      cancelText: 'No',
      icon: 'warning',
      submessage: '',
      cancelButtonColor: '#EF4A00',
      okButtonColor: '#5BD763',
    };

    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '25.438rem',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }
      row.attended = checked;
      this.cdr.detectChanges();

      const payload = { isAttended: checked };

      this.httpService
        .put<APIResponse>(`teacherevent/${row?.id}/attendance`, payload)
        .subscribe({
          next: (response) => {
            if (response.status) {
              this.getEngagementMetrics(this.selectedSchoolID);
              this.showSuccessToast(response.message);
            } else {
              this.showErrorToast(response.message);
              row.attended = originalState;
              this.cdr.detectChanges();
            }
          },
          error: (err) => {
            this.showErrorToast(err?.message || 'Failed to update attendance');
            row.attended = originalState;
            this.cdr.detectChanges();
          },
        });
    });
  }

  onDownloadConsent(event: { row: any; id: boolean }): void {
    if (!this.listViewRoles.studentList.mediaConsent) {
      return;
    }
    const { row } = event;
    this.downloadingRowId = row.id;
    this.downloadInProgress = true;
    this.updateRowDownloadingState(row.id, true);

    this.httpService
      .download(
        this.teacherMode
          ? `teacherevent/registrations/${row?.id}/media-consent/pdf`
          : `events/registrations/${row?.id}/media-consent/pdf`,
      )
      .subscribe({
        next: (res) => {
          const blob = res.body;
          if (!blob) {
            this.showErrorToast('Empty PDF received');
            this.clearDownloadingState(row.id);
            return;
          }

          const contentDisposition =
            res.headers.get('content-disposition') || '';
          const filename =
            this.extractFilename(contentDisposition) ||
            `media-consent-${row?.id}.pdf`;

          this.triggerDownload(blob, filename);
          this.showSuccessToast('Media Consent Download Successfully !');
          this.clearDownloadingState(row.id);
        },
        error: (err) => {
          this.showErrorToast(err?.message || 'Failed to download PDF');
        },
      });
  }

  onNoteUpdate(event: any) {
    let payload = {
      notes: event?.notes ?? '',
    };
    this.httpService
      .put<APIResponse>(
        this.studentViewEvent && this.Role === 'teacher'
          ? `teacherevent/${event?.row?.id}/teachernotes`
          : `events/${event?.row?.id}/adminnotes`,
        payload,
      )
      .subscribe({
        next: (response) => {
          if (response) {
            this.showSuccessToast(response?.message);
            if (this.viewMode && this.selectedSchoolID && !this.teacherMode) {
              this.fetchViewTable(this.selectedSchoolID, 'registrations');
              this.getEngagementMetrics(this.selectedSchoolID);
            } else if (
              this.viewMode &&
              this.selectedSchoolID &&
              this.teacherMode
            ) {
              this.fetchTeacherEventStudents(this.selectedSchoolID);
              this.getEngagementMetrics(this.selectedSchoolID);
            }
          }
        },
        error: (error) => {
          console.error('Status update error:', error?.message);
          this.showErrorToast(
            error?.message || 'Something went wrong. Please try again later.',
          );
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  private clearDownloadingState(rowId?: string): void {
    this.downloadInProgress = false;
    if (rowId) {
      this.updateRowDownloadingState(rowId, false);
    }
    this.downloadingRowId = null;
  }

  private updateRowDownloadingState(
    rowId: string,
    isDownloading: boolean,
  ): void {
    const fullDataIndex = this.fullData.findIndex((item) => item.id === rowId);
    if (fullDataIndex !== -1) {
      this.fullData[fullDataIndex].isDownloading = isDownloading;
    }
    const dataIndex = this.teacherStudentData.findIndex(
      (item) => item.id === rowId,
    );
    if (dataIndex !== -1) {
      this.teacherStudentData[dataIndex].isDownloading = isDownloading;
    }
  }

  private extractFilename(cd: string): string | null {
    const match = /filename\*?=(?:UTF-8'')?["']?([^"';]+)/i.exec(cd);
    return match ? decodeURIComponent(match[1]) : null;
  }

  private triggerDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }

  toggleFilterMenu(event: Event): void {
    event.stopPropagation();
    this.showFilterMenu = !this.showFilterMenu;

    if (this.showFilterMenu) {
      if (this.documentClickListener) {
        document.removeEventListener('click', this.documentClickListener);
        this.documentClickListener = null;
      }
      if (this.filterMenu) {
        this.filterMenu.filterForm.patchValue(this.currentFilters);
      }
    } else {
      this.closeFilterMenu();
    }
  }

  closeFilterMenu(): void {
    this.showFilterMenu = false;

    if (this.documentClickListener) {
      document.removeEventListener('click', this.documentClickListener);
      this.documentClickListener = null;
    }
  }

  onFiltersApplied(filters: FilterData): void {
    this.currentFilters = { ...filters };
    this.applyAdvancedFilters();
    this.closeFilterMenu();
    this.showSuccessToast('Filters applied successfully');
  }

  onFiltersCleared(): void {
    this.currentFilters = {};
    this.applyAdvancedFilters();
    this.closeFilterMenu();
    this.showSuccessToast('Filters cleared');
  }

  private applyAdvancedFilters(): void {
    let filteredData = [...this.fullData];

    if (this.search?.trim()) {
      const search = this.search.trim().toLowerCase();
      filteredData = filteredData.filter((item) =>
        item.eventTypeName.toLowerCase().includes(search),
      );
    }
  }

  private showSuccessToast(message: string): void {
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['no-padding-snackbar', 'success-toast'],
    });
  }

  private showErrorToast(message: string | null | undefined): void {
    if (!message) return;
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['no-padding-snackbar', 'error-toast'],
    });
  }

  get selectedColumns() {
    if (this.adminViewEvent) {
      return this.isEventHeld
        ? this.teacherstudentHeldadmincolumns
        : this.teacherstudentadmincolumns;
    }
    return this.isEventHeld
      ? this.teacherstudentHeldColumns
      : this.teacherstudentcolumns;
  }

  get selectedColumnsAdmin() {
    if (this.adminViewEvent) {
      return this.isEventHeld
        ? this.eventStudentsHeldList
        : this.eventStudentsList;
    }
    return this.isEventHeld
      ? this.teacherstudentHeldColumns
      : this.teacherstudentcolumns;
  }

  getEngagementMetrics(id: string) {
    if (!id) {
      return;
    }
    this.httpService
      .get<APIResponse>(`events/${id}/engagement-metrics`)
      .subscribe({
        next: (response) => {
          if (response.data) {
            this.engagementMetrics = response?.data ?? null;
          } else {
            console.error('Failed to load event details:');
          }
        },
        error: (err) => {
          console.error('Failed to load event details:', err);
          this.showErrorToast(err?.message);
        },
        complete: () => (this.loading = false),
      });
  }

  getTableSegment() {
    return this.tableSegment === 'admin'
      ? 'CSQ events'
      : this.tableSegment === 'teacher'
        ? 'Teacher-submitted work experience'
        : this.tableSegment === 'archived'
          ? 'Archived events'
          : 'Student-submitted work experience';
  }
}
